import React from 'react';
const labelCls = 'mb-2 block font-display text-[11px] font-semibold uppercase tracking-[0.14em] text-navy/70';
const controlCls = 'w-full rounded-[13px] border border-navy/10 bg-white px-4 py-3.5 font-body text-[14px] text-ink placeholder:text-ink/35 transition-colors duration-200 ease-out hover:border-navy/20 focus:border-teal focus:outline-none';
type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  id: string;
};
export function Input({
  label,
  id,
  className = '',
  ...rest
}: InputProps) {
  return <div className={className} data-id="element-289" data-mp="d18juaio1xq0">
      <label htmlFor={id} className={labelCls} data-id="element-290" data-mp="htrvh1xsmis6">
        {label}
      </label>
      <input id={id} className={controlCls} {...rest} data-id="element-291" data-mp="hvuwsi4ebyc7" />
    </div>;
}
type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  id: string;
  options: string[];
  placeholder?: string;
};
export function Select({
  label,
  id,
  options,
  placeholder,
  className = '',
  ...rest
}: SelectProps) {
  return <div className={className} data-id="element-292" data-mp="ybz4i4w7o9hi">
      <label htmlFor={id} className={labelCls} data-id="element-293" data-mp="yc8v9up2yko9">
        {label}
      </label>
      <select id={id} className={`${controlCls} appearance-none pr-10`} {...rest} data-id="element-294" data-mp="tc39gv5hrse3">
        {placeholder && <option value="" data-id="element-295" data-mp="oci2pyk2yfqt">{placeholder}</option>}
        {options.map(o => <option key={o} value={o} data-id="element-296" data-mp="kby6qyb8ti69">
            {o}
          </option>)}
      </select>
    </div>;
}
type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string;
  id: string;
};
export function Textarea({
  label,
  id,
  className = '',
  ...rest
}: TextareaProps) {
  return <div className={className} data-id="element-297" data-mp="17bcfx33wb84v">
      <label htmlFor={id} className={labelCls} data-id="element-298" data-mp="17akweqnkp0uy">
        {label}
      </label>
      <textarea id={id} rows={4} className={`${controlCls} resize-none`} {...rest} data-id="element-299" data-mp="139hhc6dcn8us" />
    </div>;
}